import { render, staticRenderFns } from "./UpdateBanner.vue?vue&type=template&id=4daf4c9b&"
import script from "./UpdateBanner.vue?vue&type=script&lang=js&"
export * from "./UpdateBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4daf4c9b')) {
      api.createRecord('4daf4c9b', component.options)
    } else {
      api.reload('4daf4c9b', component.options)
    }
    module.hot.accept("./UpdateBanner.vue?vue&type=template&id=4daf4c9b&", function () {
      api.rerender('4daf4c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/app/UpdateBanner.vue"
export default component.exports